import * as React from "react";
import { useMappedState } from "redux-react-hook";

import { IStore } from "src/core/shared/store";
import { ITag } from "src/modules/product-tags/api/product-tags.api";

/**
 * Hook to filter product tags based on the client compant layout configuration
 * @param productTags ITag[]
 * @returns
 */
const useProductTagList = (productTags: ITag[], showAllTags = false): ITag[] => {
  const { componentLayout, installedModules } = useMappedState(({ global }: IStore) => ({
    componentLayout: global.settings?.componentLayout,
    installedModules: global.settings ? global.settings.installedModules : []
  }));

  const productTagsList = React.useMemo(() => {
    if (!installedModules.includes("product-tag")) {
      return [];
    }

    if (showAllTags) {
      return productTags;
    }

    return productTags.reduce((acc, tag) => {
      const cumulative = [ ...acc ];

      if (componentLayout?.productCard.productTagTypes?.includes(tag.type)) {
        cumulative.push(tag);
      }

      return cumulative;
    }, [] as ITag[]);
  }, [
    componentLayout?.productCard.productTagTypes,
    installedModules,
    productTags,
    showAllTags
  ]);

  return productTagsList;
};

export default useProductTagList;
